// Port from: https://deopconf01.corp.hkjc.com/display/DM3631/Frontend+-+New+Banner+Ad+Integration
// this script is originally written by Sitecore vendor

import $ from 'jquery';
import Cookie from 'js-cookie';

export const bannerad_CookiePrefix = 'banner_vid';
export const bannerad_EntryTimeKey = new Date();
export const bannerad_version = '20260429';

const {
    IS_PREVIEW,
    SITECORE_BANNER_AD_CONFIG: { trackingConfig }
} = window.globalConfig;

export const initbannerAdUT = () => {
    initClearSessionStorage();

    //exit event
    window.addEventListener('beforeunload', function () {
        processInteraction();
    });

    //reach the timeout interval event process to UT
    const pushUTIntraction = setInterval(function () {
        processInteraction();
    }, trackingConfig.timeout * 1000);

    return pushUTIntraction;
};

export const handleNonSliderBanner = () => {
    var els = document.querySelectorAll('.bannerAdNonSlider');
    if (els.length <= 0) return;
    for (var i = 0; i < els.length; i++) {
        var scId = els[i].getAttribute('data-scid');
        bannerAdInteraction(scId);
    }
    // console.log('handleNonSliderBanner: ' + els.length);
};

export const bannerAdInteraction = (itemSCId = '', language = 'en-us', isSlider = true, time = 3000) => {
    if (!IS_PREVIEW && itemSCId != null && itemSCId != 'undefined' && itemSCId.length > 0) {
        // console.log('UT Track:' + process.env.REACT_APP_BANNERAD_UT_TRACK)
        var currDate = new Date().toISOString();
        var key = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substring(2);
        var type = 'pageview';
        var eventDefId = '0CFEC27E-AFF0-4B2A-8BCD-F8B9F76ACD38';
        //console.log(lan);
        var dataTime = '';
        if (isSlider) {
            if (time == 0) {
                dataTime = 'noautoplay';
                handleNoAutoplayBanner();
            } else {
                dataTime = convertToTime(time.toString());
            }
        } else {
            dataTime = 'nonslider';
        }
        if (!isSlider) {
            var hasExistsItemInSession = false;
            Object.keys(sessionStorage).forEach(function (key) {
                if (key.startsWith('bannerad')) {
                    var v = sessionStorage.getItem(key);
                    var o = JSON.parse(v);
                    if ((dataTime == 'noautoplay' || dataTime == 'nonslider') && o['ItemId'] == itemSCId) {
                        hasExistsItemInSession = true;
                    }
                    if (dataTime == 'nonslider') {
                        o['Timestamp'] = new Date().toISOString();
                        sessionStorage.setItem(key, JSON.stringify(o));
                    }
                }
            });
            if (dataTime == 'nonslider' && hasExistsItemInSession) return;
        }
        var view = hasExistsItemInSession ? 0 : 1;

        var data = JSON.stringify({
            type: type,
            Timestamp: currDate,
            Duration: dataTime,
            DefinitionId: eventDefId,
            ItemLanguage: language,
            ItemId: itemSCId,
            Url: window.location.href,
            EngagementValue: 1,
            SitecoreRenderingDevice: JSON.parse(getBannerADRenderingLayout()),
            CustomValues: JSON.parse(getDeviceType(view))
        });

        //temp store the interaction json
        if (data.length > 0) {
            sessionStorage.setItem(key, data);
        }
    }
};

export const getInteractionData = () => {
    var actList = [];
    var currDate = new Date().toISOString();
    const dateDiff = new Date().valueOf() - bannerad_EntryTimeKey.valueOf();
    var time = convertToTime(dateDiff.toString());
    Object.keys(sessionStorage).forEach(function (key) {
        if (key.startsWith('bannerad')) {
            var v = sessionStorage.getItem(key);
            var o = JSON.parse(v);
            if (o['Duration'] == 'nonslider' || o['Duration'] == 'noautoplay') {
                var pDate = new Date(o['Timestamp']);
                var cDate = new Date(currDate);
                var diffTS = cDate.valueOf() - pDate.valueOf();
                time = convertToTime(diffTS.toString());
                v = v.replace('nonslider', time).replace('noautoplay', time);
            }

            actList.push(JSON.parse(v));
        }
    });

    return actList;
};

export const initClearSessionStorage = () => {
    var newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substring(2);
    Object.keys(sessionStorage).forEach(function (key) {
        if (key.startsWith('bannerad')) {
            newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substring(2);
            var v = sessionStorage.getItem(key);
            var o = JSON.parse(v);
            if (o['Duration'] == 'noautoplay') {
                v = v.replace('"view":1', '"view":0');
                o = JSON.parse(v);
                o['Timestamp'] = new Date().toISOString();

                sessionStorage.setItem(newKey, JSON.stringify(o));
                sessionStorage.removeItem(key);
            } else {
                sessionStorage.removeItem(key);
            }
        }
    });
};

export const clearSessionStorage = () => {
    var newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substring(2);
    Object.keys(sessionStorage).forEach(function (key) {
        if (key.startsWith('bannerad')) {
            newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substring(2);
            var v = sessionStorage.getItem(key);
            var o = JSON.parse(v);
            if (o['Duration'] == 'noautoplay' || o['Duration'] == 'nonslider') {
                v = v.replace('"view":1', '"view":0');
                o = JSON.parse(v);
                o['Timestamp'] = new Date().toISOString();

                sessionStorage.setItem(newKey, JSON.stringify(o));
                sessionStorage.removeItem(key);
            } else {
                sessionStorage.removeItem(key);
            }
        }
    });
};

export const processInteraction = () => {
    const events = getInteractionData();
    if (!IS_PREVIEW && events.length > 0) {
        var userAgent = navigator.userAgent;
        var contactIdentifier = getBannerCookie(bannerad_CookiePrefix);
        fetch(trackingConfig.url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ChannelId: '2A431DC3-30DB-46C2-B405-9D5FE0429F03',
                Initiator: 'contact',
                Contact: { Source: 'BannerAd', Identifier: contactIdentifier },
                UserAgent: userAgent,
                Events: events
            })
        })
            .then((res) => res.text())
            .then((data) => {
                clearSessionStorage();
                //handleNonSliderBanner();
                // console.log('process interaction: ' + data);
            })
            // .catch((e) => console.log('process interaction error: ', e));
    }
};

// export const bannerAdClickRedirect = (link, target, targetParameter) => {
//     if (link && link !== '') {
//         if (link.indexOf('javascript:') !== -1) {
//             var javaFunc = link.split('javascript:');
//             window.eval(javaFunc[1]);
//         } else if (targetParameter == '' || targetParameter == null || typeof targetParameter == 'undefined') {
//             if (target == 'New Tab') {
//                 window.open(link, '_blank');
//             } else if (target == 'Same Tab') {
//                 window.open(link, '_top');
//             } else {
//                 window.open(link, target);
//             }
//         } else {
//             if (target == 'New Tab') {
//                 window.open(link, '_blank', targetParameter);
//             } else if (target == 'Same Tab') {
//                 window.open(link, '_top', targetParameter);
//             } else {
//                 window.open(link, target, targetParameter);
//             }
//         }
//     }
// };

// itemRedirect always false, Redirect action should be handled by frontend side correspondingly
export const bannerAdClickEvent = (itemSCId, itemUrl, itemTarget, itemTargetParameter, itemRedirect = 'false') => {
    if (!IS_PREVIEW) {
        var currDate = new Date().toISOString();
        var userAgent = navigator.userAgent;
        var contactIdentifier = getBannerCookie(bannerad_CookiePrefix);
        fetch(trackingConfig.url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ChannelId: '2A431DC3-30DB-46C2-B405-9D5FE0429F03',
                Initiator: 'contact',
                Contact: { Source: 'BannerAd', Identifier: contactIdentifier },
                UserAgent: userAgent,
                Events: [
                    {
                        type: 'goal',
                        Timestamp: currDate,
                        DefinitionId: 'BA3BD50A-2A01-4406-80A3-B2FEC6189B9C',
                        ItemId: itemSCId,
                        Url: window.location.href,
                        EngagementValue: 1,
                        SitecoreRenderingDevice: JSON.parse(getBannerADRenderingLayout()),
                        CustomValues: JSON.parse(getDeviceType())
                    }
                ]
            })
        })
            .then((res) => res.text())
            // .then((data) => console.log('process click: ' + data))
            // .catch((e) => console.log('process click error: ', e));
    }

    // if (itemRedirect != undefined && itemRedirect.toString() == 'true') {
    //     bannerAdClickRedirect(itemUrl, itemTarget, itemTargetParameter);
    // }
};

const clickEventInstance = (el) => {
    var bannerAdClickElement = $(el.target).closest('.bannerAdClick');
    var scId = bannerAdClickElement.attr('data-scid');
    var url = bannerAdClickElement.attr('data-url');
    var target = bannerAdClickElement.attr('data-target');
    var targetParameter = bannerAdClickElement.attr('data-parameter');
    var redirect = bannerAdClickElement.attr('data-redirect') || 'true';

    if ($(el.target).length > 0 && $(el.target)[0].checkVisibility()) {
        bannerAdClickEvent(scId, url, target, targetParameter, redirect);
    }
};

export const registClickEvent = () => {
    //regist click event
    var els = document.querySelectorAll('.bannerAdClick');
    // console.log('click elements count: ' + els.length);
    for (var i = 0; i < els.length; i++) {
        els[i].removeEventListener('click', clickEventInstance);
        els[i].addEventListener('click', clickEventInstance, false);
    }
};

export const handleNoAutoplayBanner = () => {
    var newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substr(2);
    var currDate = new Date().toISOString();
    Object.keys(sessionStorage).forEach(function (key) {
        if (key.startsWith('bannerad')) {
            newKey = 'bannerad' + Date.now().toString(36) + Math.random().toString(36).substr(2);
            var v = sessionStorage.getItem(key);
            var o = JSON.parse(v);
            if (o['Duration'] == 'noautoplay') {
                var pDate = new Date(o['Timestamp']);
                var cDate = new Date(currDate);
                var diffTS = cDate.valueOf() - pDate.valueOf();
                var time = convertToTime(diffTS.toString());
                v = v.replace('noautoplay', time);

                sessionStorage.setItem(newKey, v);
                sessionStorage.removeItem(key);
            }
        }
    });
};

export const getBannerADRenderingLayout = () => {
    const renderingDevice = '{"Id": "E5E0AEFD-A1E4-4337-9BE2-7BA1FDEDD99B", "Name": "Desktop"}';
    const renderingMobileDevice = '{"Id": "B039EBE1-5813-4243-81AE-EA55B2352D80", "Name": "Mobile"}';
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
        return renderingMobileDevice;
    } else {
        return renderingDevice;
    }
};

export const getDeviceType = (view = 1) => {
    const desktopDevice = '{"deviceType": "Desktop", "ver": ' + bannerad_version + ',"view":' + view + '}';
    const mobileDevice = '{"deviceType": "Mobile", "ver": ' + bannerad_version + ',"view":' + view + '}';
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
        return mobileDevice;
    } else {
        return desktopDevice;
    }
};

export const translate_date_format = (inDate = '') => {
    var str_yyyy = '',
        str_MM = '',
        str_dd = '',
        str_hh = '',
        str_mm = '',
        str = '';
    if (inDate) {
        if (inDate.split('T')) {
            if (inDate.split('T')[0]) {
                str_yyyy = inDate.split('T')[0].split('-')[0];
                str_MM = inDate.split('T')[0].split('-')[1];
                str_dd = inDate.split('T')[0].split('-')[2];
            }
            if (inDate.split('T')[1] && inDate.split('T')[1].length == 4) {
                str_hh = inDate.split('T')[1].substr(0, 2);
                str_mm = inDate.split('T')[1].substr(2, 2);
            }
        }
    }
    if (str_yyyy != '' && str_MM != '' && str_dd != '' && str_hh != '' && str_mm != '')
        str = str_yyyy + '-' + str_MM + '-' + str_dd + ' ' + str_hh + ':' + str_mm + ':00';
    return str;
};

export const convertToTime = (inSeconds = '') => {
    var dateObj = new Date(parseInt(inSeconds));
    var hours = dateObj.getUTCHours();
    var minutes = dateObj.getUTCMinutes();
    var seconds = dateObj.getSeconds();
    var milliseconds = dateObj.getMilliseconds();
    var timeString =
        hours.toString().padStart(2, '0') +
        ':' +
        minutes.toString().padStart(2, '0') +
        ':' +
        seconds.toString().padStart(2, '0') +
        '.' +
        milliseconds.toString().padStart(2, '0');
    return timeString;
};

export const setBannerCookie = (name, value) => {
    if (!Cookie.get(name)) {
        Cookie.set(name, encodeURIComponent(value), { path: '/' });
    }
};

export const getBannerCookie = (name) => {
    setBannerCookie(name, crypto.randomUUID());
    var vid = Cookie.get(name);
    return vid;
};
